import { render, staticRenderFns } from "./harga-paket.vue?vue&type=template&id=9e6bc920"
import script from "./harga-paket.vue?vue&type=script&lang=js"
export * from "./harga-paket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports